<script>
    export default {
        data: () => ({
            oldPass: "",
            newPass: ""
        })
    };
</script>

<template>
    <v-card class="fluid__card__pass" flat>
        <v-toolbar card>
            <v-toolbar-title>Redefinição de Senha</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
            <v-text-field type="password" label="Senha Atual"/>
            <v-text-field type="password" label="Nova Senha"/>
        </v-card-text>

        <v-card-actions>
            <v-btn color="primary" block depressed>Alterar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<style scoped>
    .fluid__card__pass {
        margin: 10px;
        border: 1px solid #ccc;
    }

    .theme--dark.v-card {
        border: 1px solid #000 !important;
    }
</style>
